import { render, staticRenderFns } from "./ServiceCenterResult.vue?vue&type=template&id=113bee3a&scoped=true"
import script from "./ServiceCenterResult.vue?vue&type=script&lang=js"
export * from "./ServiceCenterResult.vue?vue&type=script&lang=js"
import style0 from "./ServiceCenterResult.vue?vue&type=style&index=0&id=113bee3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113bee3a",
  null
  
)

export default component.exports